import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MsalGuard } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class ServiceBypassMsalGuard implements CanActivate {

  msalGuard : any;
  constructor(msalGuard : MsalGuard) { 
    this.msalGuard = msalGuard;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.msalGuard.canActivate(next, state); 
  }
  
}
